import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ShowImagePopupComponent } from '../show-image-popup/show-image-popup.component';
import { CustomColorPreviewPopUpComponent } from '../custom-color-preview-pop-up/custom-color-preview-pop-up.component';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
@Component({
  selector: 'app-choose-color-popup',
  templateUrl: './choose-color-popup.component.html',
  styleUrls: ['./choose-color-popup.component.scss'],
})
export class ChooseColorPopupComponent  implements OnInit {
  dashboardList: any=[]
  buttonColor:any;
  moduleNameColor:any
  subModuleButtonColor:any;
  buttonColorName:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ShowImagePopupComponent>,public dialog: MatDialog, public mobileResponsiveService: MobileResponsiveService) { }

  ngOnInit() {
    this.moduleNameColor= this.data?.moduleNameColor,
    this.subModuleButtonColor= this.data?.subModuleButtonColor,
    this.buttonColorName= this.data?.buttonColorName,
    this.dashboardList = this.data?.selectedColor
  }
  onColorChangeModule(event:any){
    this.moduleNameColor=event.target.value;
  }
  onColorChangeSubModule(event:any){
    this.subModuleButtonColor=event.target.value;
  }
  onColorChangeButton(event:any){
    this.buttonColorName=event.target.value;
  }
  onColorChange(event: any,index:any) {
    this.dashboardList[index]=event.target.value;
  }
  openColorPickers = new Set<number>(); // To track which color pickers are open

  onMouseEnter(index: number) {
    this.openColorPickers.add(index);
  }

  onMouseLeave(index: number) {
    this.openColorPickers.delete(index);
  }
  isOpen(index: number) {
    return this.openColorPickers.has(index);
  }
  addMoreDashboardColor(){
    this.dashboardList.push('#000000')
  }
  removeDashboardColor(){
    this.dashboardList.splice(1,1)
  }
  btn1Action(){
    this.dialogRef.close(false);
  }
  btn2Action(){
    let data = {
      moduleNameColor: this.moduleNameColor,
      subModuleButtonColor: this.subModuleButtonColor,
      buttonColorName: this.buttonColorName,
      dashboardList: this.dashboardList
    }
    this.dialogRef.close(data);
  }
  onClickPreview(){
    const dialogConfig = new MatDialogConfig();

    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthIfScreenSize;
    dialogConfig.data = {
      operation: 'Preview',
      moduleNameColor: this.moduleNameColor,
      subModuleButtonColor: this.subModuleButtonColor,
      buttonColorName: this.buttonColorName,
      dashboardList: this.dashboardList
    };
    dialogConfig.panelClass = ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'];
    this.dialog.open(CustomColorPreviewPopUpComponent, dialogConfig);
  }
}
